import { Button, Input } from 'antd'
import React, { useState } from 'react'
import Service from '@/services/account'
import './search.less'
import bgImg from '@/assets/search-bg.png'
import logoImg from '@/assets/logo-red.png'

export default function Search() {
  const [name, setName] = useState('')
  const [showError, setShowError] = useState(false)
  const [errMsg, setErrMsg] = useState('')

  function searchByName() {
    Service.getCode({ name }).then((res) => {
      if (res.success && res.data?.code) {
        window.location.href = '/#/cert/' + res.data.code
      } else {
        setShowError(true)
        setErrMsg(res.msg)
        setTimeout(() => {
          setShowError(false)
        }, 1000)
      }
    })
  }

  return (
    <div class="ml">
      <img class="bg" src={bgImg} />
      <div class="panel">
        <img class="logo" src={logoImg} />
        <div class="title">会员证书查询</div>
        <Input
          placeholder="请输入公司名称"
          value={name}
          onChange={(evt) => setName(evt.target.value)}
        />
        <Button onClick={searchByName}>
          查询&nbsp;<span class="iconfont">&#xe678;</span>
        </Button>
        <div class="error" style={{ opacity: showError ? 1 : 0 }}>
          {errMsg}
        </div>
      </div>
    </div>
  )
}
